export default __webpack_public_path__ + "static/media/flyer-grenoble.f75b6b18.jpg";